// /* global angular */
import moment from 'moment';
import {
  Filter
} from '../common/filter';

import {
  PATH_STRING_SEPARATOR,
  IS_IE_BROWSER,
} from '../common/config.js';


const LOGIN_URL = '/accounts/login/';


export class RouterService {
  constructor(
    $location,
    $rootScope,
    $timeout,
    CurrentFilterService,
    FiltersService,
    PermissionService,
    FilesTreeService,
    CurrentModelService,
    $q,
    $http,
    ErrorHandlerService,
    CurrentFilterDataService,
    FrameLoadService,
    LayoutService,
    LocalStorageService,
    AggregateDataService,
    md5,
    UsercardService,
    $cookies,
  ) {
    this.$cookies = $cookies;
    this.$location = $location;
    this.$rootScope = $rootScope;
    this.$rootScope.isPdf = this.pdf;
    this.$q = $q;
    this.$http = $http;
    this.$timeout = $timeout;
    this.CurrentFilterService = CurrentFilterService;
    this.FiltersService = FiltersService;
    this.PermissionService = PermissionService;
    this.FilesTreeService = FilesTreeService;
    this.CurrentModelService = CurrentModelService;
    this.ErrorHandlerService = ErrorHandlerService;
    this.CurrentFilterDataService = CurrentFilterDataService;
    this.FrameLoadService = FrameLoadService;
    this.AggregateDataService = AggregateDataService;
    this.layout = LayoutService;
    this.LocalStorageService = LocalStorageService;
    this.md5 = md5;
    this.usercards = UsercardService;

    this.$rootScope.$on('$routeUpdate', (event) => {
      if (this.layout.options.saveInterface.value)
        this.LocalStorageService.setItem('locationUrl', this.$location.url());
      this.update();
      if (!this.isFilterEditModal) this.CurrentFilterDataService.reload();
    });
    this.initialized = false;
  }

  get storageState() {
    const state = this.LocalStorageService.getItem('STATE');
    if (state) {
      try {
        return angular.fromJson(state);
      } catch (err) {
        console.warn(err);
        this.LocalStorageService.removeItem('STATE');
        return null;
      }
    }
    return null;
  }

  goToSavedUrl() {
    let url = this.$location.url();
    if (this.PermissionService.freeze_default_web_interface) {
      this.PermissionService.freeze_default_web_interface.split('&').map(p => {
        const [k, v] = p.split('=');
        if (k === 'timeFrom') this.freezedTimeFrom = v;
        if (k === 'timeTo') this.freezedTimeTo = v;
      });
      this.$location.search(this.PermissionService.freeze_default_web_interface);
      return true;
    }
    if (this.layout.options.saveInterface.value) {
      url = this.LocalStorageService.getItem('locationUrl');
      if (url) {
        this.$location.url(url);
        return true;
      }
    }
    let defaultLense = this.LocalStorageService.getItem('defaultLense');
    if (defaultLense) {
      if (this.fixDatePicker) {
        const state = this.storageState;
        if (state) {
          defaultLense = `${defaultLense}&timeFrom=${state.timeFrom}&timeTo=${state.timeTo}`;
        }
      }
      this.$location.search(defaultLense);
      return true;
    }
    if (this.fixDatePicker) {
      if (this.storageState) {
        this.timeTo = this.storageState.timeTo;
        this.timeFrom = this.storageState.timeFrom;
      }
    }
    if (this.layout.options.saveInterface.value)
      this.LocalStorageService.setItem('locationUrl', url);
    return false;
  }

  init() {
    this.$rootScope.theme = this.$cookies.get('theme') || 'light';
    this.initURL = this.$location.url();
    if (this.initialized) {
      console.error('initialize already in progress');
      return;
    }
    if (window.location.search) {
      window.location.search = '';
    }
    this.initialized = false;
    const loadings = [
      this.PermissionService.load(() => this.FilesTreeService.load()),
      this.CurrentModelService.load(),
    ];
    if (this.search().id) {
      const id = this.search().id;
      loadings.push(this.FiltersService.load()
        .then(() => this.FiltersService.loadOther(id))
        .then(() => this.FiltersService.load(id)));
    } else {
      loadings.push(this.FiltersService.load());
    }
    return this.$q
      .all(loadings)
      .then(() => {
        const currentAggregate = this.CurrentFilterService.filterBar.drilldown[0];
        const aggregateOrder = this.LocalStorageService.getItem(`aggrOrder_${currentAggregate}`);
        if (aggregateOrder) this.search('aggrOrder', aggregateOrder);
        this.CurrentFilterService.updatePanel();
        if (this.search().id) {
          const id = this.search().id;
          this.FiltersService.openedFilters = this.FiltersService.searchFilters(f => f.id == id);
        }
        this.goToSavedUrl();
        this.update();
        return this.CurrentFilterDataService.reload();
      })
      .then(() => {
        if (window.first_start) {
          this.openFrame('/analytics/welcome/');
          window.first_start = false;
        }
      })
      .then(() => {
        this.$rootScope.$broadcast('init');
      })
      .then(() => {
        return this.FrameLoadService.waitUntilLoad();
      })
      .catch(error => {
        this.ErrorHandlerService.handle(error);
      })
      .finally(() => {
        this.initialized = true;
        setTimeout(() => {
          window.status = 'INIT_COMPLETE';
          console.log('staffcop init complete');
          if (window.initCallback) window.initCallback();
        }, 1000);
      });
  }


  setStorageState(timeFrom, timeTo, fix) {
    this.LocalStorageService.setItem('STATE', `{"timeFrom": "${timeFrom}", "timeTo": "${timeTo}", "fixDatePicker": ${fix}}`);
  }

  get timeFromToday() {
    const t = new Date();
    t.setHours(0, 0, 0, 0);
    return Filter.dateToUrl(t);
  }

  get timeToToday() {
    const t = new Date();
    t.setHours(23, 59, 59, 999);
    return Filter.dateToUrl(t);
  }

  home() {
    let locationUrl = '/';
    const timeFrom = this.fixDatePicker ? this.storageState.timeFrom : this.timeFromToday;
    const timeTo = this.fixDatePicker ? this.storageState.timeTo : this.timeToToday;
    const fixDatePickerUrl = this.fixDatePicker ? '&fixDatePicker' : '';
    if (this.fixDatePicker) this.setStorageState(timeFrom, timeTo, true);
    locationUrl = `${window.location.pathname}#!/?timeFrom=${timeFrom}&timeTo=${timeTo}${fixDatePickerUrl}`;
    this.LocalStorageService.setItem('locationUrl', locationUrl);
    window.location.href = `${window.location.origin}${locationUrl}`;
    window.location.reload(true);
  }

  // /**
  //  * update state from url
  //  */

  updateContinue(state) {
    if (!this.CurrentFilterService.filter) {
      if (this.PermissionService.filterConstructor) {
        const name = this.CurrentFilterService.panel === 'usercard' ? gettext('Карточка сотрудника') : null;
        this.CurrentFilterService.newFilter(name, this.type);
      }
    }
    if (this.CurrentFilterService.filter) {
      this.updateFilter(state);
      this.updateFilterChildren(this.CurrentFilterService.filter);
    }
    this.CurrentFilterService.selectBarDim(state.barDim ||
      this.CurrentFilterService.defaultDimension);
    if (state.lookup) {
      this.CurrentFilterService.filterBar.lookup = state.lookup;
    } else {
      this.CurrentFilterService.filterBar.lookup = '';
    }
    if (state.frameUrl) {
      this.cleanRemoteUsers();
      this.CurrentFilterService.openFrame(state.frameUrl);
    } else {
      this.CurrentFilterService.reset();
    }

    if (state.remoteUsers) {
      if (!this.AggregateDataService.allRemoteUsers || this.AggregateDataService.allRemoteUsers.length < 1) {
        this.cleanRemoteUsers();
      } else {
        this.AggregateDataService.updateRemoteUsers();
        if (!this.isRemoteUsers) this.cleanRemoteUsers();
      }
    }
  }

  isValidDate(d) {
    return new Date(d) != 'Invalid Date';
  }

  update() {
    const state = this.search();
    this.validate(state);
    if (state.frameUrl == LOGIN_URL) {
      window.location = LOGIN_URL;
    }

    this.CurrentFilterService.rebuildVisibleDimensions();

    if (this.freezedTimeTo) {
      this.CurrentFilterService.timeTo = this.freezedTimeTo;
      this.CurrentFilterService.timeFrom = this.freezedTimeFrom;
    } else {
      if (state.timeTo && this.isValidDate(state.timeTo) &&
        state.timeFrom && this.isValidDate(state.timeFrom) &&
        state.timeTo >= state.timeFrom) {
        this.CurrentFilterService.timeTo = state.timeTo;
        this.CurrentFilterService.timeFrom = state.timeFrom;
        if (this.fixDatePicker) this.setStorageState(state.timeFrom, state.timeTo, true);
      } else {
        if (this.fixDatePicker) {
          this.CurrentFilterService.timeTo = this.storageState.timeTo;
          this.CurrentFilterService.timeFrom = this.storageState.timeFrom;
        } else {
          this.CurrentFilterService.timeFrom = new Date();
          this.CurrentFilterService.timeFrom.setHours(0, 0, 0, 0);
          this.CurrentFilterService.timeTo = new Date(this.CurrentFilterService.timeFrom.valueOf());
          this.CurrentFilterService.timeTo.setHours(23, 59, 59, 999);
        }
      }
    }

    if (state.lastScreenshots) {
      this.CurrentFilterService.lastScreenshots = {
        timeFrom: this.CurrentFilterService.timeFrom,
        eventTp: state.lastScreenshotsEventTp,
      };
    } else {
      delete this.CurrentFilterService.lastScreenshots;
    }

    if (state.panel) {
      this.CurrentFilterService.panel = state.panel;
    }

    if (state.modal) {
      this.CurrentFilterService.modal = state.modal;
    }

    if (state.usercard) {
      this.usercards.selectItem(state.usercard);
    }

    this.switchPane();

    if (typeof state.id !== 'undefined') {
      const id = Number(state.id);
      const getFilter = () => {
        if (this.CurrentFilterService.filter && this.CurrentFilterService.filter.isDashboard)
          this.dashboardChildren = this.CurrentFilterService.filter.children;
        const filter = this.FiltersService.findById(id);
        if (filter) {
          this.FiltersService.loadedChildren[filter.id] = true;
          this.FiltersService.openedFilters[filter.id] = id;
          this.CurrentFilterService.filter = angular.copy(filter);
          if (filter.isAnalyticPolitic) {
            this.CurrentFilterService.filter.setFilter('analytics_filter@name:name', filter.name, filter.name);
            this.CurrentFilterService.filter.isChanged = false;
          }
          this.CurrentFilterService.protoFilter = filter;
          if (!this.isFilterEditModal) this.CurrentFilterDataService.reload();
        }
      };

      if (id && !isNaN(id)) {
        if (this.FiltersService.loadedFilters[id] &&
          this.FiltersService.loadedChildren[id]
        ) {
          getFilter();
          this.updateContinue(state);
        } else if (this.FiltersService.loadedFilters[id] &&
          !this.FiltersService.loadedChildren[id])
          this.FiltersService.load(id).then(() => {
            getFilter();
            this.updateContinue(state);
          });
        else this.FiltersService.loadOther(id).then(() => {
          getFilter();
          this.updateContinue(state);
        });
      }
    } else {
      this.updateContinue(state);
    }
  }

  updateFilter(state) {
    let changed = false;

    if (state.modal) {
      if (state.tabName == 'groupEdit' && !this.FiltersService.isMarked) {
        this.search('tabName', null);
        this.search('modal', null);
      } else this.openModal();
    } else {
      this.closeModal();
    }

    if (state.chartAreaType != undefined &&
      this.CurrentFilterService.filter.chartAreaType !== state.chartAreaType) {
      this.CurrentFilterService.filter.chartAreaType = state.chartAreaType;
      changed = true;
    }

    if (state.chartAreaIsStacked != undefined &&
      this.CurrentFilterService.filter.chartAreaIsStacked !== (state.chartAreaIsStacked === 'true')) {
      this.CurrentFilterService.filter.chartAreaIsStacked = (state.chartAreaIsStacked === 'true');
      changed = true;
    }

    if (state.drilldown) {
      this.CurrentFilterService.filter.drilldown = state.drilldown.split(',');
      changed = true;
    }

    if (state.fields) {
      this.CurrentFilterService.filter.fields = state.fields.split(',');
      changed = true;
    }

    if (state.filters) {
      try {
        this.CurrentFilterService.filter.filters = JSON.parse(state.filters);
        changed = true;
      } catch (error) {
        console.error('parse filters route parameter');
      }
    } else {
      if (this.CurrentFilterService.filter.id) {
        const flt = this.FiltersService.findById(this.CurrentFilterService.filter.id);
        if (!angular.equals(flt.filters, this.CurrentFilterService.filter.filters)) {
          this.CurrentFilterService.filter.filters = flt.filters;
          changed = true;
        }
      } else {
        if (this.CurrentFilterService.filter.filters.length) {
          this.CurrentFilterService.filter.filters = [];
          changed = true;
        }
      }
    }
    if (state.query) {
      try {
        this.CurrentFilterService.filter.query = JSON.parse(state.query);
        changed = true;
      } catch (error) {
        console.error('parse query route parameter');
      }
    }
    if (state.measure) {
      this.CurrentFilterService.filter.measure = state.measure;
      changed = true;
    }
    if (state.limit || state.limit === 0) {
      this.CurrentFilterService.filter.customLimit = state.limit;
      changed = true;
    } 
    if (state.mode) {
      this.CurrentFilterService.filter.setMode(state.mode);
      changed = true;
    }
    if (state.contentType) {
      this.CurrentFilterService.filter.content_type = state.contentType;
      changed = true;
    }
    if (state.threshold) {
      this.CurrentFilterService.filter.threshold = state.threshold;
      changed = true;
    }
    if (state.threshold_type) {
      this.CurrentFilterService.filter.threshold_type = state.threshold_type;
      changed = true;
    }
    if (state.url) {
      this.CurrentFilterService.filter.url = state.url;
      changed = true;
    }

    if (state.listType) {
      this.CurrentFilterService.filter.listType = state.listType;
      changed = true;
    }

    if (state.orders) {
      const orders = state.orders.split(',');
      if (!angular.equals(this.CurrentFilterService.filter.orders, orders)) {
        changed = true;
        this.CurrentFilterService.filter.orders = orders;
      }
    }

    if (state.top_len) {
      this.CurrentFilterService.filter.top_len = state.top_len;
      changed = true;
    }

    if (state.repOrders) {
      const repOrders = state.repOrders.split(',');
      if (!angular.equals(this.CurrentFilterService.filter.repOrders, repOrders)) {
        changed = true;
        this.CurrentFilterService.filter.repOrders = repOrders;
      }
    }
    if (state.repOrderDirs) {
      const repOrderDirs = state.repOrderDirs.split(',');
      if (!angular.equals(this.CurrentFilterService.filter.repOrderDirs, repOrderDirs)) {
        changed = true;
        this.CurrentFilterService.filter.repOrderDirs = repOrderDirs;
      }
    }

    if (state.orderDirs) {
      const orderDirs = state.orderDirs.split(',');
      if (!angular.equals(this.CurrentFilterService.filter.orderDirs, orderDirs)) {
        changed = true;
        this.CurrentFilterService.filter.orderDirs = orderDirs;
      }
    }

    if (state.order) {
      const order = state.order;
      if (this.CurrentFilterService.filter.order !== order) {
        this.CurrentFilterService.filter.order = order;
        changed = true;
      }
    }

    if (state.orderDir) {
      const orderDir = state.orderDir;
      if (this.CurrentFilterService.filter.orderDir !== orderDir) {
        this.CurrentFilterService.filter.orderDir = orderDir;
        changed = true;
      }
    }

    if (state.aggrOrder) this.CurrentFilterService.filterBar.aggrOrder = state.aggrOrder;
    else delete this.CurrentFilterService.filterBar.aggrOrder;

    if (state.aggrRemote) this.CurrentFilterService.filterBar.aggrRemote = true;
    else delete this.CurrentFilterService.filterBar.aggrRemote;

    if (state.simular) {
      this.CurrentFilterService.filter.simular = state.simular;
      changed = true;
    }

    if ('children' in state && this.dashboardChildren) {
      if (this.CurrentFilterService.filter.children &&
        this.CurrentFilterService.filter.isCardOrDashboard) {
        const children = state.children ? state.children.split(',') : [];
        changed = true;
        this.CurrentFilterService.filter.children =
          children.map(id => {
            if (id === '0') return this.dashboardChildren.find(f => (!f.id && !f.dIndex));
            return this.dashboardChildren.find(f => (id === '' + f.id) || (id === f.dIndex)) ||
              (id.indexOf('_') == -1 ? this.FiltersService.findById(parseInt(id, 0)) : null);
          }).filter(f => f)
          .concat(this.dashboardChildren
            .filter(f => (children.indexOf('' + f.id) == -1) && (children.indexOf('' + f.dIndex) == -1)));
        delete this.dashboardChildren;
      } else delete state.children;
    }

    this.CurrentFilterService.filter.isChanged = changed &&
      !this.CurrentFilterService.filter.isAnalyticPolitic && !this.CurrentFilterService.filter.isCardFilter;
    if (this.CurrentFilterService.filter.isCardFilter && this.CurrentFilterService.filter.hasFilters()) {
      this.CurrentFilterService.buildCardFilter();
    }
    if (changed) {
      this.$rootScope.$broadcast('filterChanged');
    }
  }

  get frameUrl() {
    return this.search().frameUrl;
  }

  get url() {
    return this.search().url;
  }

  get mode() {
    return this.search().mode;
  }

  // require fot expotr to pdf
  get pdf() {
    return this.search().pdf;
  }

  updateFilterChildren(filter) {
    filter.children.forEach(child => this.updateFilterChild(filter, child));
  }

  updateFilterChild(parent, child) {
    if (!child) return;
    child.timeFrom = parent.timeFrom;
    child.timeTo = parent.timeTo;
    if (this.CurrentFilterService.filter.isCard) {
      parent.filters.forEach((f) => child.removeFilter(f.dimension, f.value));
      child.filters = child.filters.concat(parent.filters);
    }
    this.updateFilterChildren(child);
  }

  /**
   * filter out invalid keys
   * @param state
   */
  validate(state) {
    if (!this.PermissionService.filterConstructor) {
      if (state.panel === 'constructor') {
        state.panel = 'catalog';
      }
    }
  }

  set chartAreaType(chartAreaType) {
    if (this.isFilterEditModal) return;
    this.search('chartAreaType', chartAreaType);
  }

  set chartAreaIsStacked(chartAreaIsStacked) {
    if (this.isFilterEditModal) return;
    this.search('chartAreaIsStacked', (chartAreaIsStacked ? 'true' : 'false'));
  }

  set filterId(id) {
    if (this.isFilterEditModal) return;
    this.search('id', id);
  }


  set panel(panel) {
    if (this.isFilterEditModal) return;
    this.search('panel', panel);
  }

  set fixDatePicker(fix) {
    if (fix == this.fixDatePicker) return;
    this.setStorageState(Filter.dateToUrl(this.CurrentFilterService.timeFrom),
      Filter.dateToUrl(this.CurrentFilterService.timeTo), fix);
    this.search('fixDatePicker', fix ? true : null);
  }

  get fixDatePicker() {
    const fix = this.search().fixDatePicker;
    if (fix) return true;
    const state = this.storageState;
    return state && state.fixDatePicker;
  }

  set timeTo(timeTo) {
    if (this.isFilterEditModal) return;
    const time = Filter.dateToUrl(timeTo);
    this.CurrentFilterService.timeTo = time;
    this.search('timeTo', time);
    if (this.fixDatePicker) {
      this.setStorageState(this.storageState.timeFrom, time, true);
    }
  }

  set timeFrom(timeFrom) {
    if (this.isFilterEditModal) return;
    const time = Filter.dateToUrl(timeFrom);
    this.CurrentFilterService.timeFrom = time;
    this.search('timeFrom', time);
    if (this.fixDatePicker) {
      this.setStorageState(time, this.storageState.timeTo, true);
    }
  }

  set threshold(threshold) {
    if (this.isFilterEditModal) return;
    this.search('threshold', threshold);
  }

  set filter(filter) {
    if (this.isFilterEditModal) return;
    const query = this.search();
    this.clearFilter(query);
    if (filter.id) {
      query.id = filter.id;
      this.originalFilter = this.FiltersService.findById(filter.id);
    }
    if (!this.originalFilter) {
      this.originalFilter = new Filter();
    }
    if (filter.threshold !== this.originalFilter.threshold) {
      query.threshold = filter.threshold;
    } else {
      delete query.threshold;
    }

    if (filter.threshold_type !== this.originalFilter.threshold_type) {
      query.threshold_type = filter.threshold_type;
    } else {
      delete query.threshold_type;
    }

    if (!angular.equals(filter.drilldown, this.originalFilter.drilldown)) {
      query.drilldown = filter.drilldown.join(',');
    }

    if (!angular.equals(filter.fields, this.originalFilter.fields)) {
      if (filter.fields) query.fields = filter.fields.join(',');
      else delete query.fields;
    }

    if ((!filter.filters || !filter.filters.length) && this.originalFilter.filters &&
      this.originalFilter.filters.length || (!this.originalFilter.filters || !this.originalFilter.filters.length) &&
      filter.filters && filter.filters.length || filter.filters && filter.filters.length &&
      this.originalFilter.filters && this.originalFilter.filters.length &&
      !angular.equals(filter.filters, this.originalFilter.filters)) {
      query.filters = angular.toJson(filter.filters);
    }
    if (filter.hasQuery !== this.originalFilter.hasQuery ||
      !angular.equals(filter.query, this.originalFilter.query)) {
      query.query = angular.toJson(filter.query);
    }
    if (filter.measure !== this.originalFilter.measure) {
      query.measure = filter.measure;
    }
    if (filter.customLimit !== this.originalFilter.customLimit) {
      query.limit = filter.customLimit;
    }
    if (filter.isReports && filter.url !== this.originalFilter.url) {
      query.url = filter.url;
    }
    if (filter.mode !== this.originalFilter.mode) {
      query.mode = filter.mode;
    }
    if (filter.isExplore && filter.listType !== this.originalFilter.listType) {
      query.listType = filter.listType;
    }

    if (filter.content_type !== this.originalFilter.content_type) {
      query.contentType = filter.content_type;
    }

    if (this.CurrentFilterService.frameUrl) {
      query.frameUrl = this.CurrentFilterService.frameUrl;
    }
    if (filter.isChartArea) {
      if (filter.chartAreaType !== this.originalFilter.chartAreaType) query.chartAreaType = filter.chartAreaType;
      if (filter.chartAreaIsStacked !== this.originalFilter.chartAreaIsStacked) query.chartAreaIsStacked = filter.chartAreaIsStacked ? 'true' : 'false';
    }
    if (!angular.equals(filter.orderDirs, this.originalFilter.orderDirs)) {
      query.orderDirs = filter.orderDirs.join(',');
    }
    if (!angular.equals(filter.orders, this.originalFilter.orders)) {
      query.orders = filter.orders.join(',');
    }

    if (filter.isReports) {
      delete query.orderDirs;
      delete query.orders;

      if (filter.top_len !== this.originalFilter.top_len) {
        query.top_len = filter.top_len;
      }
      if (!angular.equals(filter.repOrders, this.originalFilter.repOrders)) {
        if (filter.repOrders) query.repOrders = filter.repOrders.join(',');
      }
      if (!angular.equals(filter.repOrderDirs, this.originalFilter.repOrderDirs)) {
        if (filter.repOrderDirs) query.repOrderDirs = filter.repOrderDirs.join(',');
      }
    } else {
      delete query.repOrderDirs;
      delete query.repOrders;
    }

    if (filter.order !== this.originalFilter.order || filter.orderDir !== this.originalFilter.orderDir) {
      query.orderDir = filter.orderDir;
      query.order = filter.order;
    }

    if (this.CurrentFilterService.modal) {
      query.modal = this.CurrentFilterService.modal;
    }

    if (filter.isDashboard) {
      let childrenChanged = false;
      filter.children.map((f, i) => {
        let fChanged = false;
        if (i >= this.originalFilter.children.length) fChanged = true;
        else {
          const f2 = this.originalFilter.children[i];
          fChanged = !Object.keys(f).every(k => {
            const chang = k !== 'dIndex' && k !== 'children' && k !== '_changed' &&
              !angular.equals(f[k], f2[k]);
            return !chang;
          });
        }
        if (fChanged) {
          f.isChanged = true;
          childrenChanged = true;
        }
      });
      if (childrenChanged) {
        const ids = filter.children.reduce((o, f, i) => {
          if (!f.deleted) o[f.id ? f.id : (f.dIndex ? f.dIndex : 0)] = i;
          return o;
        }, {});
        if (filter.children) query.children = Object.keys(ids).sort((a, b) => ids[a] - ids[b]).join(',');
      }
    }
    this.search(query);
  }

  set barDim(dim) {
    if (this.isFilterEditModal) return;
    const aggregateOrder = this.LocalStorageService.getItem(`aggrOrder_${dim}`);
    if (aggregateOrder) this.search('aggrOrder', aggregateOrder);
    this.search('barDim', dim);
    this.search('lookup', null);
  }

  setFilter(...args) {
    this.CurrentFilterService.filter.setFilter(...args);
    this.CurrentFilterService.filter.mode = 'explore';
    this.CurrentFilterService.rebuildVisibleDimensions();
    this.filterChanged();
  }

  toggleFilter(filter) {
    this.CurrentFilterService.filter.toggleFilter(filter);
    this.CurrentFilterService.filter.mode = 'explore';
    this.CurrentFilterService.rebuildVisibleDimensions();
    this.filterChanged();
  }

  removeConditions() {
    this.search('query', 'null');
  }

  changeCut(dimension, value, modal) {
    this.FilterEditorService.cut = {
      dimension: dimension,
      value: value
    };
    this.modal = modal;
  }


  drilldownFilter2(dimension, value, label, mode) {
    if (!dimension) return;
    this.$timeout(() => {
      if (this.isFilterEditModal) return;
      if (!value && !label && value !== '' && label !== '') {
        this.CurrentFilterService.filter.reSetFilter(dimension);
      } else {
        this.CurrentFilterService.filter.reSetFilter({
          dimension,
          value,
          label
        });
      }
      this.CurrentFilterService.filter.mode = mode ? mode : 'explore';
      if (this.CurrentFilterService.filter.content_type === 'dimensioncardfilter') {
        this.CurrentFilterService.filter.content_type = 'filter';
      }
      delete this.CurrentFilterService.filter.id;
      this.CurrentFilterService.rebuildVisibleDimensions();
      this.filterChanged();
    }, 10);
  }


  drilldownFilter(dimension, value, label, mode = 'explore', url = '') {
    if (!dimension) return;
    this.$timeout(() => {
      if (this.isFilterEditModal) return;
      if (!value && !label) {
        this.CurrentFilterService.filter.toggleFilter(dimension);
      } else {
        this.CurrentFilterService.filter.toggleFilter({
          dimension,
          value,
          label
        });
      }
      this.CurrentFilterService.filter.mode = mode;
      if (this.CurrentFilterService.filter.content_type === 'dimensioncardfilter') {
        this.CurrentFilterService.filter.content_type = 'filter';
      }
      if (mode === 'reports') {
        this.CurrentFilterService.filter.url = url;
        delete this.CurrentFilterService.filter.content_type;
      }
      delete this.CurrentFilterService.filter.id;
      this.CurrentFilterService.rebuildVisibleDimensions();
      this.filterChanged();
    }, 10);
  }

  drilldownFilterHTML(cuts, isCurrFilterCuts) {
    this.$timeout(() => {
      const addCuts = [];
      if (isCurrFilterCuts) {
        this.CurrentFilterService.filter.filters.map(cut => {
          if (cuts.every(c => this.CurrentModelService.model.getDimension(c.dimension).name !=
              this.CurrentModelService.model.getDimension(cut.dimension).name)) addCuts.push(cut);
        });
      }
      if (this.isFilterEditModal) return;
      const filter = new Filter();
      cuts.map(c => filter.toggleFilter(c));
      addCuts.map(c => filter.toggleFilter(c));
      filter.mode = 'explore';
      delete filter.id;
      filter.url = '/analytics/report/facts/';
      if (filter.order === 'record_count') {
        filter.order = 'local_time';
      }
      const src = this.CurrentFilterService.getReportUrl(filter);
      window.open(src, '_blank');
    }, 10);
  }

  drilldownCut(dimension, value, label, mode) {
    if (!dimension || this.isFilterEditModal) return;
    if (!value && !label) {
      this.CurrentFilterService.filter.addCut(dimension);
    } else {
      this.CurrentFilterService.filter.addCut({
        dimension,
        value,
        label
      });
    }
    this.CurrentFilterService.filter.mode = mode ? mode : 'explore';
    if (this.CurrentFilterService.filter.content_type === 'dimensioncardfilter') {
      this.CurrentFilterService.filter.content_type = 'filter';
    }
    delete this.CurrentFilterService.filter.id;
    this.CurrentFilterService.rebuildVisibleDimensions();
    this.filterChanged();
  }

  drilldownCuts(cuts, mode) {
    if (this.isFilterEditModal) return;
    cuts.map(cut => {
      if (!cut.dimension) return null;
      this.CurrentFilterService.filter.addCut(cut);
    });

    this.CurrentFilterService.filter.mode = mode ? mode : 'explore';
    if (this.CurrentFilterService.filter.content_type === 'dimensioncardfilter') {
      this.CurrentFilterService.filter.content_type = 'filter';
    }
    delete this.CurrentFilterService.filter.id;
    this.CurrentFilterService.rebuildVisibleDimensions();
    const filter = this.CurrentFilterService.filter;
    this.$timeout(() => {
      this.CurrentFilterService.filter = filter;
      this.filterChanged();
    }, 10);
  }

  removeCut(dimension, value, label, mode) {
    if (!dimension) return;
    this.CurrentFilterService.filter.mode = mode ? mode : 'explore';
    this.CurrentFilterService.filter.removeFilter(dimension, value, label, mode);
    delete this.CurrentFilterService.filter.id;
    this.CurrentFilterService.rebuildVisibleDimensions();
    this.filterChanged();
  }

  cleanFilter(dimension) {
    if (!dimension || this.isFilterEditModal) return;
    this.CurrentFilterService.filter.cleanFilter(dimension);
    this.filterChanged();
  }

  addFilter(...args) {
    this.CurrentFilterService.filter.addFilter(...args);
    this.filterChanged();
  }

  addTimeFilter(...args) {
    this.CurrentFilterService.filter.addTimeFilter(...args);
    this.filterChanged();
  }

  removeFilter(...args) {
    this.CurrentFilterService.filter.removeFilter(...args);
    this.filterChanged();
  }

  invertFilter(...args) {
    this.CurrentFilterService.filter.invertFilter(...args);
    this.filterChanged();
  }

  addKeyword(...args) {
    if (this.isFilterEditModal) return;
    this.CurrentFilterService.filter.addKeyword(...args);
    this.filterChanged();
  }

  set mode(mode) {
    if (this.isFilterEditModal) return;
    this.panel = 'constructor';
    this.search('mode', mode);
    this.search('frameUrl', null);
    this.cleanRemoteUsers();
    this.search('editDasboard', null);
    if (mode !== 'reports') {
      this.search('repOrders', null);
      this.search('repOrderDirs', null);
    }
  }

  // aggregateOrder == 'statAsc','statDesc','nameAsc',  nameDesc'
  set aggregateOrder(order) {
    const currentAggregate = this.CurrentFilterService.filterBar.drilldown[0];
    this.LocalStorageService.setItem(`aggrOrder_${currentAggregate}`, order);
    this.search('aggrOrder', order);
  }

  get aggregateOrder() {
    return this.search().aggrOrder;
  }

  set aggregateRemote(isRemote) {
    if (isRemote) this.CurrentFilterService.filterBar.aggrRemote = true;
    else delete this.CurrentFilterService.filterBar.aggrRemote;
    this.search('aggrRemote', isRemote ? true : null);
  }

  get aggregateRemote() {
    return this.search().aggrRemote;
  }


  set fields(fields) {
    this.search('fields', fields);
  }

  get fields() {
    return this.search().fields;
  }

  set type(type) {
    this.search('type', type);
  }

  get type() {
    return this.search().type;
  }

  // modal window
  set modal(modal) {
    if (this.isFilterEditModal) return;
    this.search('modal', modal);
  }

  get modal() {
    return this.search().modal;
  }

  get tabName() {
    return this.search().tabName;
  }

  set tabName(tabName) {
    this.search('tabName', tabName);
  }

  get isFilterEditModal() {
    return this.modal === 'filter-edit' || this.modal === 'new-filter';
  }

  removeModal() {
    this.search('modal', null);
    this.search('tabName', null);
    this.CurrentFilterService.modal = null;
  }

  setPane(isPane) {
    if (isPane) this.search('paneClose', null);
    else this.search('paneClose', true);
  }

  switchPane() {
    angular.element(document).trigger('showDimensions', !this.paneClose);
  }

  get paneClose() {
    return !!this.search().paneClose;
  }

  set listType(mode) {
    if (this.isFilterEditModal) return;
    this.search('listType', mode);
  }

  get listType() {
    return this.search().listType;
  }

  setMeasure(measure) {
    this.CurrentFilterService.filter.measure = measure;
    if (this.CurrentFilterService.filter.send_threshold) this.CurrentFilterService.filter.threshold_type = measure;
    this.filterChanged();
  }

  setLimit(limit) {
    if (this.CurrentFilterService.filter.customLimit === limit) return;
    this.CurrentFilterService.filter.customLimit = limit;
    this.filterChanged();
  }

  selectFilter(id, isEdit) {
    this.isEditDasboard = false;
    const query = Object.assign({}, this.search());
    this.clearFilter(query);
    query.id = id;
    if (isEdit) query.modal = 'filter-edit';
    this.search(query);
  }

  clearFilter(query) {
    delete query.id;
    delete query.allFilters;
    delete query.chartAreaType;
    delete query.chartAreaIsStacked;
    delete query.drilldown;
    delete query.filters;
    delete query.query;
    delete query.measure;
    delete query.mode;
    delete query.url;
    delete query.listType;
    delete query.frameUrl;
    delete query.repOrders;
    delete query.repOrderDirs;
    delete query.orders;
    delete query.top_len;
    delete query.orderDirs;
    delete query.repOrders;
    delete query.repOrderDirs;
    delete query.order;
    delete query.orderDir;
    delete query.type;
    delete query.limit;
    delete query.modal;
    delete query.simular;
    delete query.fields;
    delete query.childrenMinimized;
    delete query.children;
    delete query.contentType;
    delete query.threshold;
    delete query.threshold_type;
    delete query.tabName;
  }

  resetFilter() {
    const query = this.search();
    const id = query.id;
    this.clearFilter(query);
    if (id) {
      query.id = id;
    }
    this.search(query);
  }

  onDeleteFilter() {
    const query = this.search();
    this.clearFilter(query);
    this.search(query);
  }

  replaceDim(newDim, oldDim) {
    if (this.CurrentFilterService.filter.hasDrilldown(newDim.toString())) {
      return;
    }
    this.CurrentFilterService.filter.replaceDrilldown(newDim.toString(), oldDim.toString());
    this.CurrentFilterService.filter.changed();
    this.search('frameUrl', null);
    this.cleanRemoteUsers();
    this.search('editDasboard', null);
    this.filterChanged();
  }

  selectDim(dim) {
    if (this.CurrentFilterService.filter.hasDrilldown(dim.toString())) {
      return;
    }
    this.CurrentFilterService.filter.addDrilldown(dim.toString());
    this.CurrentFilterService.filter.changed();
    this.search('frameUrl', null);
    this.cleanRemoteUsers();
    this.search('editDasboard', null);
    this.filterChanged();
  }

  removeDim(dim) {
    if (!this.CurrentFilterService.filter.hasDrilldown(dim.toString())) {
      return;
    }
    this.CurrentFilterService.filter.removeDrilldown(dim.toString());
    this.CurrentFilterService.filter.changed();
    this.filterChanged();
  }

  drilldown(dim) {
    if (dim.dimension || dim.is_flat) {
      this.CurrentFilterService.filterBar.drill = dim.toString();
      this.filterChanged();
    }
  }

  lookup(value) {
    this.search('lookup', value || null);
  }

  generateReport(...args) {
    this.CurrentFilterService.generateReport(...args);
    this.filterChanged();
    this.search('frameUrl', null);
    this.cleanRemoteUsers();
    this.search('editDasboard', null);
  }

  openFrame(url) {
    this.search('frameUrl', url);
    this.search('editDasboard', null);
  }

  openNewWindow(more) {
    if (typeof(more) !== 'string') {
      more = '';
    }
    const src = this.CurrentFilterService.frameUrl ||
      this.CurrentFilterService.getReportUrl(this.CurrentFilterService.filter);
    window.open(src + more, '_blank');
  }

  filterChanged() {
    this.filter = this.CurrentFilterService.filter;
  }

  frameChanged() {
    if (this.CurrentFilterService.frameUrl) {
      this.search('frameUrl', this.CurrentFilterService.frameUrl);
    } else {
      this.search('frameUrl', null);
    }
  }

  newFilter(type) {
    // this.panel = 'constructor';
    this.search('editDasboard', null);
    this.modal = 'new-filter';
    this.type = type;
    const filter = this.CurrentFilterService.createNewFilter(null, type);
    if (type === 'filteraggregatealertfilter') {
      filter.setMode('stat');
      filter.send_threshold = true;
    }

    this.FilterEditorService.editModal({
      filter: filter,
      asNew: !filter.id,
      selectFilter: true,
      type: type,
    });
  }


  openCard(filterCut) {
    this.CurrentFilterService.newFilter(null);
    const query = this.search();
    query.contentType = 'dimensioncardfilter';
    query.filters = angular.toJson([filterCut]);
    delete query.frameUrl;
    delete query.allFilters;
    delete query.id;
    delete query.url;
    delete query.mode;
    this.search(query);
  }

  filtersGroupEdit() {
    this.tabName = 'groupEdit';
    this.modal = 'filter-edit';
  }

  openModal() {
    if (this.modal) {
      if (this.modal === 'new-filter') {
        this.FilterEditorService.editModal({
          filter: this.CurrentFilterService.createNewFilter(null, this.type),
          asNew: false,
          selectFilter: true,
          type: this.type,
          tabName: this.tabName,
        });
      } else if (this.modal === 'filter-edit') {
        let filter = this.CurrentFilterService.filter;
        if (filter.isAnalyticPolitic && filter.id) {
          filter = this.FiltersService.findById(filter.id);
        }
        this.FilterEditorService.editModal({
          filter: filter,
          asNew: false,
          selectFilter: true,
          tabName: this.tabName,
          type: this.type,
        });
      } else if (this.modal === 'cut-edit' && this.FilterEditorService.cut) {
        this.FilterEditorService.editModal({
          filter: this.CurrentFilterService.filter,
          asNew: false,
          selectFilter: true,
        });
      } else if (this.modal === 'cuts-edit') {
        this.FilterEditorService.editModal({
          asNew: false
        });
      } else if (this.modal === 'rules-edit') {
        this.FilterEditorService.editModal({
          asNew: false
        });
      } else this.removeModal();
    }
  }

  closeModal() {
    if (!this.FilterEditorService) return;
    if (this.FilterEditorService.isOpened) this.FilterEditorService.cancel();
    if (this.type) this.type = undefined;

    if (this.CurrentFilterService.filter.isPolitic &&
      this.CurrentFilterService.filter.parent_id) {
      this.selectFilter(this.CurrentFilterService.filter.parent_id);
    }

    this.CurrentFilterService.modal = null;
    if (this.imageDialog) this.imageDialog.close();
  }


  cleanRemoteUsers() {
    this.search('remoteUsers', null);
    if (this.CurrentFilterService && this.CurrentFilterService.lastScreenshots) {
      this.search('lastScreenshots', null);
      this.search('lastScreenshotsEventTp', null);
      delete this.CurrentFilterService.lastScreenshots;
    }
  }

  setRemoteUsers() {
    if (!this.AggregateDataService.remoteUsers && this.AggregateDataService.remoteUsers.length < 1) return;
    this.search('frameUrl', null);
    this.search('url', null);
    this.search('mode', null);
    this.setPane(false);
    this.search('remoteUsers', true);
    this.search('lastScreenshots', null);
    this.search('lastScreenshotsEventTp', null);
    delete this.CurrentFilterService.lastScreenshots;
  }

  setLastScreenshots(eventType) {
    this.search('frameUrl', null);
    this.search('remoteUsers', null);
    this.search('url', null);
    this.search('mode', null);
    this.search('lastScreenshots', true);
    this.search('lastScreenshotsEventTp', eventType);
  }

  get isLastScreenshots() {
    return this.search().lastScreenshots;
  }

  get isRemoteUsers() {
    return this.search().remoteUsers && this.AggregateDataService.remoteUsers &&
      this.AggregateDataService.remoteUsers.length > 0;
  }

  isRemoteOpened(remoteCell) {
    const search = this.search();
    return search.remoteUsers || (search.frameUrl && search.frameUrl.startsWith(`/remote/?hwid=${remoteCell.hwid}`));
  }

  findSimular(factId) {
    this.search('simular', factId);
  }

  toNeighbourEvents() {
    let queryCanged = false;
    if (!this.needToShowFact || !this.needToShowFact.fact) return;

    const currentFact = this.needToShowFact.fact;
    const dateFact = moment(currentFact.local_time.substr(0, 19));
    if (!dateFact.isValid()) return;
    const minutes = this.layout.options.toNeighboursMinutes.value;
    const dateStart = moment(dateFact).subtract(minutes, 'minutes');
    const dateEnd = moment(dateFact).add(minutes, 'minutes');
    if (new Date(this.search().timeFrom).getTime() !== dateStart.toDate().getTime()) {
      this.timeFrom = dateStart.toDate();
      queryCanged = true;
    }
    if ((new Date(this.search().timeTo)).getTime() !== dateEnd.toDate().getTime()) {
      this.timeTo = dateEnd.toDate();
      queryCanged = true;
    }

    const filters = [];
    if (currentFact['agent_agent.id'] && currentFact['agent_agent.guid'] && currentFact['agent_agent.computer_name']) {
      filters.push({
        'dimension': 'agent_agent@computer_name:computer_name',
        'value': currentFact['agent_agent.id'] + PATH_STRING_SEPARATOR +
          currentFact['agent_agent.guid'] + PATH_STRING_SEPARATOR +
          currentFact['agent_agent.computer_name'],
        'label': currentFact['agent_agent.computer_name'],
        'predicates': []
      });
    }
    if (currentFact['agent_account.user_name']) {
      filters.push({
        'dimension': 'agent_account@user_name:user_name',
        'value': currentFact['agent_account.user_name'],
        'label': currentFact['agent_account.user_name'],
        'predicates': []
      });

      const limit = minutes * 100;
      if (!angular.equals(this.CurrentFilterService.filter.filters, filters) ||
        this.CurrentFilterService.filter.customLimit !== limit) {
        this.CurrentFilterService.filter.customLimit = limit;
        this.CurrentFilterService.filter.filters = filters;
        queryCanged = true;
      }
    }

    this.needToShowFact = {
      needShowtoNeighbours: true,
      fact: currentFact,
    };

    if (queryCanged) {
      this.filterChanged();
    }
  }

  search(...args) {

    if (IS_IE_BROWSER) {

      const hash = this.$location.search()['hash'] || '';

      let history = window.HISTORY;
      if (!history) {
        history = JSON.parse(this.LocalStorageService.getItem('HISTORY') || '{}');
      }

      let state = angular.copy(history[hash] || {});

      if (!args.length) return state;

      const param = args[0];
      const value = args[1];

      const oldState = JSON.stringify(state);

      if (param && !value) {
        if (typeof param === 'object') {
          state = param;
        } else {
          delete state[param];
        }
      } else state[param] = value;

      const newState = JSON.stringify(state);

      if (oldState !== newState) {
        const newHash = this.md5.createHash(newState);
        history[newHash] = state;
        window.HISTORY = history;
        this.LocalStorageService.setItem('HISTORY', JSON.stringify(history));
        this.$location.search('hash', newHash);
      }
      return state;

    } else {
      return this.$location.search(...args);
    }
  }
}



// WEBPACK FOOTER //
// ./src/core/router.service.js